var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOvercastClouds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    fill: "lightskyblue",
    transform: "scale(0.6)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "lightskyblue",
    stroke: "lightskyblue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230 590 c0 -16 5 -30 10 -30 6 0 10 14 10 30 0 17 -4 30 -10 30 -5 0 -10 -13 -10 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 582 c0 -18 12 -42 21 -42 14 0 10 26 -6 40 -9 8 -15 8 -15 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 578 c-14 -14 -16 -38 -3 -38 10 0 26 39 19 46 -2 2 -10 -2 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 531 c-41 -21 -80 -83 -80 -128 0 -17 11 -55 25 -85 l25 -53 -23 -3 c-44 -6 -78 -25 -92 -53 -29 -55 -13 -104 48 -146 40 -28 41 -28 203 -28 l163 0 31 30 c19 18 33 43 36 67 5 30 11 38 34 43 40 9 81 56 86 101 6 51 -23 99 -73 120 -41 18 -52 24 -98 54 -16 11 -42 20 -57 20 -17 0 -31 8 -38 20 -14 27 -82 60 -122 60 -18 0 -49 -8 -68 -19z m123 -14 c41 -18 68 -48 49 -55 -8 -2 -29 -17 -47 -33 -19 -17 -44 -29 -61 -29 -38 -1 -74 -21 -90 -51 l-12 -24 -11 28 c-15 38 -14 61 3 102 27 64 100 90 169 62z m176 -101 c15 -14 37 -26 50 -26 32 0 91 -61 91 -94 0 -39 -21 -76 -51 -92 -39 -20 -46 -18 -80 21 -19 21 -43 37 -64 41 -19 3 -40 13 -46 21 -40 47 -118 56 -173 18 -45 -31 -46 -31 -46 0 0 14 12 37 26 51 20 21 32 25 62 22 31 -4 40 0 61 25 13 16 34 33 45 38 35 15 96 3 125 -25z m-120 -140 c15 -14 35 -26 44 -26 29 0 63 -21 80 -50 26 -44 21 -78 -17 -116 l-34 -34 -143 0 c-134 0 -145 1 -185 25 -70 41 -85 95 -38 141 20 21 32 25 62 22 31 -4 40 0 61 25 13 16 34 33 45 38 35 15 96 3 125 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 430 c0 -5 8 -10 19 -10 10 0 30 -9 45 -21 21 -17 26 -18 26 -5 0 16 -48 46 -75 46 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 280 c0 -5 8 -10 19 -10 10 0 30 -9 45 -21 21 -17 26 -18 26 -5 0 16 -48 46 -75 46 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 200 c-24 -24 -25 -49 -6 -76 19 -25 31 -12 14 15 -17 28 -1 55 36 59 14 2 24 8 21 13 -10 16 -44 10 -65 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 495 c14 -16 40 -20 40 -6 0 9 -24 21 -42 21 -6 0 -6 -6 2 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393 503 c-7 -2 -13 -9 -13 -14 0 -14 26 -10 40 6 10 12 10 15 -1 14 -8 0 -20 -3 -26 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 400 c0 -5 14 -10 30 -10 17 0 30 5 30 10 0 6 -13 10 -30 10 -16 0 -30 -4 -30 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 305 c-8 -9 -8 -15 -2 -15 18 0 42 12 42 21 0 14 -26 10 -40 -6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvercastClouds);
export default __webpack_public_path__ + "static/media/overcast-clouds.372a78b64445e3193952a3d911124135.svg";
export { ForwardRef as ReactComponent };